import { retiredListLoader } from "_shared/_views/list-pages/retired-list-redirect";
import { RETIRED_TEAMS_TABS, TEAMS_PATH, teamsTabPath } from "_shared/teams/teams-list-chips";
import { PageTab } from "_shared/teams/teams-tabs";
import { LoaderFunctionArgs, redirect } from "react-router";

export default async function teamsLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect(teamsTabPath(PageTab.Templates));
  return routeParams;
}

/**
 * `/teams/:pageTab`. The page's tabs are Teams and Templates since #6718: `/teams/teams-on` and
 * `/teams/teams-working-for-me` open Teams with that perspective's chip, and `/teams/archived` the
 * Templates tab's Archived chip, each keeping the link's other parameters. A segment the page has no
 * tab for opens Teams.
 */
export const teamsListLoader = retiredListLoader({
  basePath: TEAMS_PATH,
  retired: RETIRED_TEAMS_TABS,
  inner: ({ params }) => {
    const tab = Object.values(PageTab).find((each) => each === params.pageTab?.toLowerCase());
    return tab ? null : redirect(teamsTabPath(PageTab.Teams));
  },
});
